import { ChangeDetectionStrategy, Component, inject, Input } from '@angular/core'
import { RouterModule } from '@angular/router'

import { ProfileModule } from '@app/modules/profile/profile.module'
import { UIModule } from '@app/modules/ui/ui.module'
import { MemberService } from '@app/services/member.service'

import type { Conversation } from '../../models/conversation.model'
import { ConversationStore } from '../store/conversation.store'

@Component({
  selector: 'sb-locked-message',
  templateUrl: './locked-message.component.html',
  styleUrls: ['./locked-message.component.scss'],
  imports: [RouterModule, UIModule, ProfileModule],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class LockedMessageComponent {
  readonly conversationStore = inject(ConversationStore)
  readonly memberService = inject(MemberService)

  @Input({ required: true }) conversation!: Conversation
}
